import { AbstractLocalStorage } from "./AbstractLocalStorage";

import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("LocalStorage.LandinPageStorage");

/**
 * Wrapper to access LocalStorage data from landing page.
 *
 * These methods must be provided by Landing Page:
 * - ggsGetStoredGameData
 * - ggsStoreGameData
 */
export class LandinPageStorage extends AbstractLocalStorage {
    /**
     * Read data from landing page based on current section.
     *
     * Try to access landing page data using ExternalInterface.
     * If everything fails, create an empty object and store data on memory.
     */
    public read(): Promise<any> {
        return new Promise((resolve, reject) => {
            logger.info("reading data from landing page using ggsGetStoredGameData.");

            ExternalInterface.asyncCall("ggsGetStoredGameData", this._section)
                .then(result => {
                    logger.info("got data from ggsGetStoredGameData.");
                    logger.info(result);

                    this._data = result || {};
                    resolve(this._data);
                })
                .catch(reason => {
                    logger.error("failed to read data from ggsGetStoredGameData.");

                    this._data = {};
                    resolve(this._data);
                });
        });
    }

    public write(): void {
        try {
            logger.info("writing data on landing page using ggsStoreGameData.");
            ExternalInterface.call("ggsStoreGameData", this._section, this._data);
        } catch (error) {
            logger.error("failed to store data using ggsStoreGameData.");
        }
    }
}
